export const getPlmUserName = (user: any) => {
    return user ? user.lastname || user.lastName || user.firstname || user.firstName || user.name : ""
};
export const getPlmStatusColor = (statusLabel: string) => {
    if (statusLabel === "未处理") return "#999999"
    if (statusLabel === "处理中") return "rgb(252,162,16)"
    if (statusLabel === "待复核") return "rgb(189,202,141)"
    if (statusLabel === "已完成") return "#4ca691"
    if (statusLabel === "已暂停") return "#999999"
    return "#999999"
}